import { type AuthUser } from '@vip/shared';

/**
 * Gaat de uitleg vanzelf open?
 *
 * Voor iedereen die kan inloggen, en alleen zolang hij hem nog niet heeft
 * gehad; daarna haal je hem zelf op uit het menu.
 *
 * Hier hing `meeting:create` voor: de uitleg was van de buddy, want de andere
 * vinkjes kwamen niet aan het aanleveren toe. De tekst schrijft de lezer nu
 * geen rol meer toe, en dan is er geen reden om iemand die de app voor het
 * eerst ziet zonder introductie binnen te laten. Wie hem niet hoeft, klikt hem
 * weg; dat telt als gezien.
 *
 * Er staat bewust geen rechtencheck meer: zonder vinkje is er geen inlog, dus
 * bestaat er ook geen `user`.
 */
export const uitlegHoortOpenTeGaan = (user: AuthUser | null | undefined): boolean =>
  Boolean(user && !user.uitlegGezien);
